import { render, staticRenderFns } from "./MfaConfig.vue?vue&type=template&id=61595574&scoped=true"
import script from "./MfaConfig.ts?vue&type=script&lang=ts&external"
export * from "./MfaConfig.ts?vue&type=script&lang=ts&external"
import style0 from "./MfaConfig.vue?vue&type=style&index=0&id=61595574&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61595574",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61595574')) {
      api.createRecord('61595574', component.options)
    } else {
      api.reload('61595574', component.options)
    }
    module.hot.accept("./MfaConfig.vue?vue&type=template&id=61595574&scoped=true", function () {
      api.rerender('61595574', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Auth/pages/MfaConfig/MfaConfig.vue"
export default component.exports